import Search from "container/SearchContainer.js";
import Main from "container/MainContainer.js";
import RestaurantDetails from "container/RestaurantDetailsContainer.js";
import Login from "container/LoginContainer.js";
import Signup from "container/SignupContainer.js";
import UserData from "container/UserDataContainer.js";
import Activity from "container/ActivityContainer.js";
import UserFavorites from "container/UserFavoritesContainer.js";
import UserReviews from "container/UserReviewsContainer.js";
import PolicyPrivacy from "container/PolicyPrivacyContainer.js";
import UserCheckIn from "container/UserCheckInContainer.js";
import ContactForm from "container/ContactContainer.js";

// import ContentPaste from "@material-ui/icons/ContentPaste";

var dashRoutes = [
  {
    path: "/search",
    component: Search,
    layout: ""
  },
  {
    path: "/contact-us",
    component: ContactForm,
    layout: ""
  },
  {
    path: "/restaurant",
    component: RestaurantDetails,
    layout: ""
  },
  {
    path: "/login",
    component: Login,
    layout: ""
  },
  {
    path: "/signup",
    component: Signup,
    layout: ""
  },
  {
    path: "/userData",
    component: UserData,
    layout: ""
  },
  {
    path: "/activity",
    component: Activity,
    layout: ""
  },
  {
    path: "/userReviews",
    component: UserReviews,
    layout: ""
  },
  {
    path: "/userFavorites",
    component: UserFavorites,
    layout: ""
  },
  {
    path: "/userCheck",
    component: UserCheckIn,
    layout: ""
  },
  {
    path: "/policy-privacy",
    component: PolicyPrivacy,
    layout: ""
  },
  {
    path: "/",
    component: Main,
    layout: "/"
  },
  { redirect: true, path: "/", pathTo: "/", name: "Dashboard" }
];
export default dashRoutes;
